export enum RestaurantKind {
  AdministrativeRestaurant = "Restaurant administratif",
  ApprovedRestaurant = "Restaurant agréé",
  Brewery = "Brasserie",
  Cafeteria = "Cafétéria",
  CoffeeCorner = "Coffee Corner",
  CrousAndGo = "crous and go",
  FoodTruck = "Foodtruck",
  GroceryStore = "épicerie",
  Kiosk = "Kiosque",
  ManagedRestaurant = "Restaurant géré",
  Pizzeria = "Pizzéria",
  Restaurant = "Restaurant",
  SandwichShop = "Sandwicherie",
  Scooter = "Triporteur",
  SelfService = "Libre-service",
  Space = "Space"
}
